import { ControlType, FetchStatus, IDataSource, IEntity, Property, PropertyType } from "../../../base/types";
import { DataContextProvider, useDataContext } from "../../page/context";
import React, { FC } from "react";

import { DesignerMode } from "../../types";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useEffect } from "react";
import { useGetProperties } from "../../../base/hooks";

export const ListComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const tooltip: string | undefined = properties[Property.Tooltip];

    if (designerMode === DesignerMode.Draft) {
        return (
            <div className={className}>
                {children}
            </div>)
    }

    return (
        <div className={className} title={tooltip}>
            <ListRows {...props}>
                {children}
            </ListRows>
        </div>
    )
}

export const ListRows = ({ children }: { children?: React.ReactNode }) => {
    const { type, result: data, status, dataSource } = useDataContext()
    if (status !== FetchStatus.Success || !data || type !== "List")
        return <></>

    return <>
        {data.records.map((row, index) => <React.Fragment key={index}>
            <DataContextProvider>
                <ListRowProducer data={row} dataSource={dataSource} />
                <div>{children}</div>
            </DataContextProvider>
        </React.Fragment>)}
    </>
}

const ListRowProducer = ({ data, dataSource }: { data: IEntity, dataSource?: IDataSource }) => {
    const { setData, setDataSource } = useDataContext()

    useEffect(() => {
        if (!dataSource) return;

        setDataSource(dataSource)
        // eslint-disable-next-line
    }, [dataSource])

    useEffect(() => {
        setData({ type: "Card", result: data, status: FetchStatus.Success })
        // eslint-disable-next-line
    }, [data])

    return <></>
}

Registry.addControl({
    id: "65c0ca48-a38b-4df6-99bd-e0d66c2ccb47",
    name: "List",
    type: ControlType.List,
    properties: [
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: ListComponent
})
